import { Stack, Typography } from '@mui/material';

import CpuIcon from '@/components/Icons/CpuIcon';
import VersionsCountByStatus from '@/sections/Workspace/VersionsCountByStatus';
import {
  colorForStatus,
  getEntityDeploymentsCount,
  getVersionsByStatus,
  sortVersionsByStatus,
} from '@/sections/Workspace/utils';
import { ColorScale } from '@/theme/colors';

import ProductionStatus from '../../sections/ProductionStatus';
import {
  CardNameContainer,
  IconContainer,
  ModelData,
  StatusColor,
  StatusColors,
  StatusContainer,
} from '../../styled';
import Actions from '../Actions';
import { usePinnedAPI } from '../hooks';
import { CardProps } from './types';

function Model({ model }: CardProps) {
  const versionsByStatus = sortVersionsByStatus(getVersionsByStatus(model.versionCountByStatus));
  const totalCount = getEntityDeploymentsCount(model);
  const { getPinActionItem } = usePinnedAPI();

  return (
    <ModelData>
      <Stack gap={1.5} pt={2} pb={2.5} pl={2.5} pr={2} flex={1}>
        <Stack spacing={0.5}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <CardNameContainer>
              <IconContainer>
                <CpuIcon
                  sx={{
                    color: ColorScale.blue[600],
                  }}
                />
              </IconContainer>
              <Typography
                variant="h4"
                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {model.name}
              </Typography>
            </CardNameContainer>
            <Stack direction="row" gap={0.2}>
              {getPinActionItem(model.id, model.name)}
              <Actions modelId={model.id} modelName={model.name} variant="minimal" />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <StatusContainer>
        <ProductionStatus primary={model.primaryVersion} />
        <VersionsCountByStatus options={versionsByStatus} />
      </StatusContainer>
      <StatusColors>
        {versionsByStatus
          .filter(([, count]) => count)
          .map(([status, count]) => (
            <StatusColor
              key={status}
              sx={{
                width: `${(count / totalCount) * 100}%`,
                backgroundColor: colorForStatus[status],
              }}
            />
          ))}
      </StatusColors>
    </ModelData>
  );
}

export default Model;
